export default __webpack_public_path__ + "static/grouped-bar-9fc3a666111bfccb2050081ca908af2f.png";